function getFoldersFromCodeArray(codeArray) {
	const rootFolder = { name: "", childrens: [] };

	codeArray.forEach(
		({code, path}) => {
			const segments = path.substr(1).split(/[/\\]+/);
			let currentNode = rootFolder;
			let partialPath = "";

			for (const segment of segments) {
		  
				partialPath+= `/${segment}`;
				let childNode = currentNode.childrens.find((node) => node.name === segment);
		  
				if (!childNode) {
				  childNode = { id: partialPath, name: segment, childrens: [] };
				  currentNode.childrens.push(childNode);
				}
		  
				currentNode = childNode;

			}
			currentNode.source=code;

		}
	)
	return rootFolder.childrens;
}



export default {getFoldersFromCodeArray};
